import React, { useState } from 'react';
import { Box, Tab, Tabs, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const NavigationBar = ({
  activeTab,
  setActiveTab,
  searchQuery,
  setSearchQuery,
}) => {
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
    setSearchQuery(''); // Optional: Clear search when switching tabs
  };

  const [isPopupOpen, setPopupOpen] = useState(false);

  const handleOpenPopup = () => {
    toast.error('Feature Unavailable');
    // setPopupOpen(true);
  };

  const handleClosePopup = () => {
    setPopupOpen(false);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '24px 24px 12px 24px',
      }}
    >
      <Tabs
        value={activeTab}
        onChange={handleChange}
        aria-label="Navigation tabs"
        indicatorColor="none"
        textColor="true"
        sx={{
          '.MuiTabs-fixed': {
            margin: 'auto 0px !important',
          },
          '.MuiTabs-flexContainer': {
            gap: '12px',
          },
          '.MuiTab-root': {
            padding: '4px 12px',
            minHeight: '39px',
            flexDirection: 'row',
            alignItems: 'center',
            background: 'transparent',
            borderRadius: '12px',
            '&.Mui-selected': {
              background: '#212121',
              color: '#FFFFFF',
            },
          },
        }}
      >
        <Tab label="Request" sx={{ typography: 'body1' }} />
        {/* <Tab disabled={true} label="Permissions" sx={{ typography: 'body1' }} /> */}
        {/* <Tab disabled='true' label="User" sx={{typography:'body1'}}/> */}
        <Tab label="User" sx={{ typography: 'body1' }} />
        {/* <Tab disabled={true} label="Groups" sx={{ typography: 'body1' }} /> */}
      </Tabs>
      <Box
        sx={{
          display: 'flex',
          gap: '16px',
          alignItems: 'center',
          justifyContent: 'flex-end',
          marginLeft: 'auto',
        }}
      >
        <TextField
          variant="outlined"
          size="small"
          placeholder="Search...."
          value={searchQuery} // Controlled input
          onChange={e => setSearchQuery(e.target.value)} // Update searchQuery
          InputProps={{
            startAdornment: <SearchIcon sx={{ fill: '#666666' }} />,
            sx: {
              background: '#FAFAFA',
              border: '1px solid #E6E6E6',
              borderRadius: '8px',
              padding: '4px 16px',
            },
          }}
          sx={{
            width: '264px',
            height: '50px',
            '.MuiOutlinedInput-root': {
              borderRadius: '12px',
            },
          }}
        />
        {/* <Button
          variant="contained"
          onClick={handleOpenPopup}
          sx={{
            background: '#007BFF',
            borderRadius: '12px',
            padding: '12px 12px',
            color: '#FFFFFF',
            textTransform: 'none',
            width: '150px',
            height: '47px',
            fontSize: '1.1rem',
            fontWeight: 'bold',
            '&:hover': {
              background: '#0056b3',
            },
          }}
        >
          Create Group
        </Button> */}
      </Box>
      {/* <CreateGroupPopup open={isPopupOpen} onClose={handleClosePopup} /> */}
      <ToastContainer />
    </Box>
  );
};

export default NavigationBar;
